import * as React from 'react'
import CircularProgress, {
    circularProgressClasses,
    CircularProgressProps,
} from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { ui } from '../../../utils/uiTokens'

export default function CircularProgressWithLabel(
    props: CircularProgressProps & { value: number, color: string },
) {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress
                variant="determinate"
                sx={{
                    color: ui.track,
                }}
                size={props.size || 80}
                thickness={6}
                {...props}
                value={100}
            />

            <CircularProgress
                variant="determinate"
                size={props.size || 80}
                thickness={6}
                sx={{
                    color: props.color === 'secondary' ? ui.green : ui.pink,
                    position: 'absolute',
                    left: 0,
                    [`& .${circularProgressClasses.circle}`]: {
                        strokeLinecap: 'round',
                    },
                }}
                {...props}
            />

            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography
                    variant="caption"
                    component="div"
                    color="text.secondary"
                    sx={{
                        fontWeight: 600,
                        fontSize: '18px',
                        color: ui.ink,
                    }}
                >
                    {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    )
}
